export const HOME_PAGE_URL = '/';
export const CHARACTERS_PAGE_URL = '/characters';
export const LOCATIONS_PAGE_URL = '/locations';
export const EPISODES_PAGE_URL = '/episodes';
export const FAVORITES_PAGE_URL = '/favorites';
